export default "/assets/images/graph-dust-sm.bf183a2a37fb3fd8.png";